export default __webpack_public_path__ + "static/media/blankClipboards.e97934b0.png";